<script>
export default {
  name: "totalCount",
  props:['totalCount']

}
</script>

<template>
  <div class="countArea">
    <div class="totalText">
      Total :
    </div>
    <div class="countText">
      {{totalCount}}
    </div>
  </div>
</template>
<style scoped>
.countArea{
  display: flex;
}
.totalText{
  font-weight: bold;
}
.countText{
  margin-left: 2px;
  min-width: 28px;
  color: #052C65;
  font-weight: bold;
}

</style>